module.exports = {"131125100":"安平镇","131125101":"马店镇","131125102":"南王庄镇","131125103":"大子文镇","131125104":"东黄城镇","131125200":"大何庄乡","131125201":"程油子乡","131125202":"西两洼乡","131125400":"高新技术产业开发区","131125401":"社区建设办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131125.json
// module id = 336
// module chunks = 0